module.exports = __webpack_public_path__ + "static/media/carousel-active.9eeae4a9.svg";